import React from 'react';

import { permissionSectionPropType } from './permissionsData';
import PermissionRow from './PermissionRow';
import SummaryCheckbox from './SummaryCheckboxContainer';
import { getSectionDependencies } from './helpers';

const PermissionSection = ({ data }) => (
  <div className="c-permissions--section" display-if={!data.hide}>
    <div className="c-permissions--section-row c-permissions--section-header">
      <div>
        <SummaryCheckbox dependencies={getSectionDependencies(data)} />
      </div>
      <div className="c-permissions--permission-name">{data.sectionTitle}</div>
      <div><span display-if={data.showColumns.includes('view')}>View</span></div>
      <div><span display-if={data.showColumns.includes('addEdit')}>Add/Edit</span></div>
      <div><span display-if={data.showColumns.includes('book')}>Book</span></div>
      <div><span display-if={data.showColumns.includes('modify')}>Modify</span></div>
      <div><span display-if={data.showColumns.includes('history')}>History</span></div>
      <div><span display-if={data.showColumns.includes('cancel')}>Cancel</span></div>
      <div><span display-if={data.showColumns.includes('blockTime')}>Block Time</span></div>
    </div>
    {data.rows.map(permissionRow => (
      <PermissionRow
        display-if={!permissionRow.hide}
        key={permissionRow.rowId}
        data={permissionRow}
        sectionData={data}
      />
    ))}
  </div>
);

PermissionSection.propTypes = {
  data: permissionSectionPropType.isRequired,
};

export default PermissionSection;
